import { Pipe, PipeTransform } from '@angular/core';
import { SituacaoContratoEnum } from './../shared/enums/situacao-contrato.enum';

@Pipe({
  name: 'situacaoContrato'
})
export class SituacaoContratoPipe implements PipeTransform {

  transform(situacaoContrato: SituacaoContratoEnum): string {
    return (() => {
      switch (situacaoContrato) {
        case SituacaoContratoEnum.SITUACAO_EM_DIA:
          return 'Em dia';
        case SituacaoContratoEnum.SITUACAO_EM_ATRASO:
          return 'Em atraso';
        case SituacaoContratoEnum.SITUACAO_AGUARDANDO_PAGAMENTO:
          return 'Aguardando pagamento';
        default:
          return '';
      }
    })();
  }

}
